<span
  *ngIf="leg?.flightStatus | jbIncludesSubstring: 'CANCELLED'"
  class="fl pv1 half-percent-column"
></span>
<span
  *ngIf="!(leg?.flightStatus | jbIncludesSubstring: 'CANCELLED')"
  class="fl pv1 one-percent-column"
></span>
<div class="fl w-20 flight-number-column f4-ns pv1-ns">
  <span class="clip">{{ (flightTrackerText$ | async)?.tabletStickyFlightNumber }}</span>
  {{ leg?.flightNo }}
</div>
